import React from 'react'
import ResumeImproverApp from './components/ResumeImproverApp'
import './App.css'

function App() {
  return (
    <div className="App">
      <ResumeImproverApp />
    </div>
  )
}

export default App